module.exports = __webpack_public_path__ + "img/antes_despues_243.fe502fff.png";